import { store } from './store';
import authActions from '@iso/redux/auth/actions';
import Promise from 'promise'

export default () =>
  new Promise(() => {
    store.dispatch(authActions.checkAuthorization());
  });
